import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { Menu, MenuProps } from 'antd';

import NotificationsIcon from 'assets/images/menu/notifications.svg?react';
import { EMainRoutes } from 'shared/typings';
import { useSidebarSlice } from 'widgets/Sidebar';

interface ISubNavProps extends MenuProps {}

export const SubNav: FC<ISubNavProps> = ({ className, ...props }) => {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const { toggleOpened } = useSidebarSlice();

	return (
		<Menu
			{...props}
			className={className}
			mode="inline"
			items={[
				{
					label: <Link to={`/${EMainRoutes.NOTIFICATIONS}`}>{t('Центр уведомлений')}</Link>,
					key: EMainRoutes.NOTIFICATIONS,
					icon: <NotificationsIcon />,
				},
			]}
			onClick={() => toggleOpened(false)}
			selectedKeys={[pathname.replace('/', '')]}
			selectable={false}
		/>
	);
};
